import { Suspense, type SxProps, type Theme } from '@lingoda/ui';
import { PostCheckoutProgressBar, Stepper } from '@lingoda/student-post-checkout';
import type { PropsWithChildren, ReactNode } from 'react';

export interface PostCheckoutFrameProps {
    onBack?: () => void;
    onSkip?: () => void;
    stepperChildrenSx?: SxProps<Theme>;
    progressBar?: ReactNode;
}

export const PostCheckoutFrame = ({
    children,
    stepperChildrenSx,
    onBack,
    onSkip,
    progressBar = <PostCheckoutProgressBar />,
}: PropsWithChildren<PostCheckoutFrameProps>) => {
    return (
        <Stepper
            handleBack={onBack}
            handleSkip={onSkip}
            stepperChildrenSx={stepperChildrenSx}
            progressBar={progressBar}
        >
            <Suspense variant="circular">{children}</Suspense>
        </Stepper>
    );
};
